/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Meeesh API
 * The Meeesh API

Rate limiting:
- default: 60 requests/min (applies to all routes).
- write: 60 requests/min (applies to POST/PUT/PATCH/DELETE).
- public: 120 requests/min (applies only to redirect tracker).

Some endpoints may set stricter write limits (e.g., earn start/claim).
On limit, the API returns 429 with a single Retry-After (seconds).
For redirect, clients can include X-Device-Id to ensure device-keyed limits.
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  UserBalanceDto,
  UserCapDto,
  UserControllerCompleteOnboarding200,
  UserControllerCompleteOnboarding429,
  UserControllerGetCap429,
  UserControllerGetMe429,
  UserControllerGetMyBalance429,
  UserControllerGetMyTransactions429,
  UserControllerGetMyTransactionsParams,
  UserDto,
  UserTransactionDto
} from '.././model';

import { fetcher } from '../../fetcher';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Returns profile information of the currently authenticated user.
 * @summary Get current authenticated user
 */
export const userControllerGetMe = (
    
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<UserDto>(
      {url: `/users/me`, method: 'GET', signal
    },
      options);
    }
  

export const getUserControllerGetMeQueryKey = () => {
    return [`/users/me`] as const;
    }

    
export const getUserControllerGetMeQueryOptions = <TData = Awaited<ReturnType<typeof userControllerGetMe>>, TError = null | UserControllerGetMe429>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetMe>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserControllerGetMeQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof userControllerGetMe>>> = ({ signal }) => userControllerGetMe(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: Infinity, retry: 1, retryDelay: 3000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userControllerGetMe>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UserControllerGetMeQueryResult = NonNullable<Awaited<ReturnType<typeof userControllerGetMe>>>
export type UserControllerGetMeQueryError = null | UserControllerGetMe429


export function useUserControllerGetMe<TData = Awaited<ReturnType<typeof userControllerGetMe>>, TError = null | UserControllerGetMe429>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetMe>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userControllerGetMe>>,
          TError,
          Awaited<ReturnType<typeof userControllerGetMe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserControllerGetMe<TData = Awaited<ReturnType<typeof userControllerGetMe>>, TError = null | UserControllerGetMe429>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetMe>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userControllerGetMe>>,
          TError,
          Awaited<ReturnType<typeof userControllerGetMe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserControllerGetMe<TData = Awaited<ReturnType<typeof userControllerGetMe>>, TError = null | UserControllerGetMe429>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetMe>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get current authenticated user
 */

export function useUserControllerGetMe<TData = Awaited<ReturnType<typeof userControllerGetMe>>, TError = null | UserControllerGetMe429>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetMe>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserControllerGetMeQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Retrieves the maximum allowed target amount for a new dream. Cap is 0 (locked) until user donates capActivationThresholdGross to others.
 * @summary Get target amount cap for the current user
 */
export const userControllerGetCap = (
    
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<UserCapDto>(
      {url: `/users/me/cap`, method: 'GET', signal
    },
      options);
    }
  

export const getUserControllerGetCapQueryKey = () => {
    return [`/users/me/cap`] as const;
    }

    
export const getUserControllerGetCapQueryOptions = <TData = Awaited<ReturnType<typeof userControllerGetCap>>, TError = null | UserControllerGetCap429>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetCap>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserControllerGetCapQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof userControllerGetCap>>> = ({ signal }) => userControllerGetCap(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: Infinity, retry: 1, retryDelay: 3000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userControllerGetCap>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UserControllerGetCapQueryResult = NonNullable<Awaited<ReturnType<typeof userControllerGetCap>>>
export type UserControllerGetCapQueryError = null | UserControllerGetCap429


export function useUserControllerGetCap<TData = Awaited<ReturnType<typeof userControllerGetCap>>, TError = null | UserControllerGetCap429>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetCap>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userControllerGetCap>>,
          TError,
          Awaited<ReturnType<typeof userControllerGetCap>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserControllerGetCap<TData = Awaited<ReturnType<typeof userControllerGetCap>>, TError = null | UserControllerGetCap429>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetCap>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userControllerGetCap>>,
          TError,
          Awaited<ReturnType<typeof userControllerGetCap>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserControllerGetCap<TData = Awaited<ReturnType<typeof userControllerGetCap>>, TError = null | UserControllerGetCap429>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetCap>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get target amount cap for the current user
 */

export function useUserControllerGetCap<TData = Awaited<ReturnType<typeof userControllerGetCap>>, TError = null | UserControllerGetCap429>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetCap>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserControllerGetCapQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Marks the current user onboarding flow as completed. Idempotent operation.
 * @summary Mark onboarding as completed
 */
export const userControllerCompleteOnboarding = (
    
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<UserControllerCompleteOnboarding200 | null>(
      {url: `/users/me/onboarding/complete`, method: 'POST', signal
    },
      options);
    }
  


export const getUserControllerCompleteOnboardingMutationOptions = <TError = null | UserControllerCompleteOnboarding429,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userControllerCompleteOnboarding>>, TError,void, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof userControllerCompleteOnboarding>>, TError,void, TContext> => {

const mutationKey = ['userControllerCompleteOnboarding'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userControllerCompleteOnboarding>>, void> = () => {
          

          return  userControllerCompleteOnboarding(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UserControllerCompleteOnboardingMutationResult = NonNullable<Awaited<ReturnType<typeof userControllerCompleteOnboarding>>>
    
    export type UserControllerCompleteOnboardingMutationError = null | UserControllerCompleteOnboarding429

    /**
 * @summary Mark onboarding as completed
 */
export const useUserControllerCompleteOnboarding = <TError = null | UserControllerCompleteOnboarding429,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userControllerCompleteOnboarding>>, TError,void, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof userControllerCompleteOnboarding>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getUserControllerCompleteOnboardingMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Returns paginated and filtered transaction history for the current user. Includes donations sent/received, referral bonuses, earn rewards, farming claims, etc.
 * @summary Get user transaction history
 */
export const userControllerGetMyTransactions = (
    params?: UserControllerGetMyTransactionsParams,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<UserTransactionDto[]>(
      {url: `/users/me/transactions`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getUserControllerGetMyTransactionsQueryKey = (params?: UserControllerGetMyTransactionsParams,) => {
    return [`/users/me/transactions`, ...(params ? [params]: [])] as const;
    }

    
export const getUserControllerGetMyTransactionsQueryOptions = <TData = Awaited<ReturnType<typeof userControllerGetMyTransactions>>, TError = null | UserControllerGetMyTransactions429>(params?: UserControllerGetMyTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetMyTransactions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserControllerGetMyTransactionsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof userControllerGetMyTransactions>>> = ({ signal }) => userControllerGetMyTransactions(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: Infinity, retry: 1, retryDelay: 3000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userControllerGetMyTransactions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UserControllerGetMyTransactionsQueryResult = NonNullable<Awaited<ReturnType<typeof userControllerGetMyTransactions>>>
export type UserControllerGetMyTransactionsQueryError = null | UserControllerGetMyTransactions429


export function useUserControllerGetMyTransactions<TData = Awaited<ReturnType<typeof userControllerGetMyTransactions>>, TError = null | UserControllerGetMyTransactions429>(
 params: undefined |  UserControllerGetMyTransactionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetMyTransactions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userControllerGetMyTransactions>>,
          TError,
          Awaited<ReturnType<typeof userControllerGetMyTransactions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserControllerGetMyTransactions<TData = Awaited<ReturnType<typeof userControllerGetMyTransactions>>, TError = null | UserControllerGetMyTransactions429>(
 params?: UserControllerGetMyTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetMyTransactions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userControllerGetMyTransactions>>,
          TError,
          Awaited<ReturnType<typeof userControllerGetMyTransactions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserControllerGetMyTransactions<TData = Awaited<ReturnType<typeof userControllerGetMyTransactions>>, TError = null | UserControllerGetMyTransactions429>(
 params?: UserControllerGetMyTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetMyTransactions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get user transaction history
 */

export function useUserControllerGetMyTransactions<TData = Awaited<ReturnType<typeof userControllerGetMyTransactions>>, TError = null | UserControllerGetMyTransactions429>(
 params?: UserControllerGetMyTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetMyTransactions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserControllerGetMyTransactionsQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Returns detailed wallet balance breakdown for the current user across all currencies. Includes available (withdrawable) and reserved (locked in active dreams) balances.
 * @summary Get user wallet balance
 */
export const userControllerGetMyBalance = (
    
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<UserBalanceDto>(
      {url: `/users/me/balance`, method: 'GET', signal
    },
      options);
    }
  

export const getUserControllerGetMyBalanceQueryKey = () => {
    return [`/users/me/balance`] as const;
    }

    
export const getUserControllerGetMyBalanceQueryOptions = <TData = Awaited<ReturnType<typeof userControllerGetMyBalance>>, TError = null | UserControllerGetMyBalance429>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetMyBalance>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserControllerGetMyBalanceQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof userControllerGetMyBalance>>> = ({ signal }) => userControllerGetMyBalance(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: Infinity, retry: 1, retryDelay: 3000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userControllerGetMyBalance>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UserControllerGetMyBalanceQueryResult = NonNullable<Awaited<ReturnType<typeof userControllerGetMyBalance>>>
export type UserControllerGetMyBalanceQueryError = null | UserControllerGetMyBalance429


export function useUserControllerGetMyBalance<TData = Awaited<ReturnType<typeof userControllerGetMyBalance>>, TError = null | UserControllerGetMyBalance429>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetMyBalance>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userControllerGetMyBalance>>,
          TError,
          Awaited<ReturnType<typeof userControllerGetMyBalance>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserControllerGetMyBalance<TData = Awaited<ReturnType<typeof userControllerGetMyBalance>>, TError = null | UserControllerGetMyBalance429>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetMyBalance>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userControllerGetMyBalance>>,
          TError,
          Awaited<ReturnType<typeof userControllerGetMyBalance>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserControllerGetMyBalance<TData = Awaited<ReturnType<typeof userControllerGetMyBalance>>, TError = null | UserControllerGetMyBalance429>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetMyBalance>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get user wallet balance
 */

export function useUserControllerGetMyBalance<TData = Awaited<ReturnType<typeof userControllerGetMyBalance>>, TError = null | UserControllerGetMyBalance429>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetMyBalance>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserControllerGetMyBalanceQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



